export default (errCode, id, router) => {
  const route = errCodeRouter[errCode];
  // 매핑되지 않은 코드는 기본 NotFound 페이지로 보낸다.
  router.push(route ? route(id) : `/err/${id}`);
};

const errCodeRouter = {
  "1000": id => {
    return `/err/${id}`;
  }

  // "2000": id => {
  //   return `/err/hidden/${id}`;
  // }
};



// WEBPACK FOOTER //
// ./src/js/error.js